import _extends from "@babel/runtime/helpers/extends";
import React, { useContext, useEffect } from 'react';
import { MenuGroup } from '@atlaskit/menu';
import { FocusManagerContext } from './focus-manager';

/**
 * It sets focus to the first avatar when popup is open.
 */
const PopupAvatarGroup = ({
  children,
  isLoading,
  maxHeight,
  maxWidth = 800,
  minHeight,
  minWidth = 320,
  onClick,
  role,
  setInitialFocusRef,
  spacing,
  testId,
  ...rest
}) => {
  const {
    menuItemRefs
  } = useContext(FocusManagerContext);
  useEffect(() => {
    setInitialFocusRef === null || setInitialFocusRef === void 0 ? void 0 : setInitialFocusRef(menuItemRefs[0]);
  }, [menuItemRefs, setInitialFocusRef]);
  return /*#__PURE__*/React.createElement(MenuGroup, _extends({
    isLoading: isLoading,
    maxHeight: maxHeight,
    maxWidth: maxWidth,
    minHeight: minHeight,
    minWidth: minWidth,
    onClick: onClick,
    role: role,
    spacing: spacing,
    testId: testId
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  }, rest), children);
};
export default PopupAvatarGroup;